import { renderPageToCanvas } from "./renderPage";

/** Save a data URL as a file. */
export const downloadDataUrl = (dataUrl, filename) => {
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Export a page as a PNG at the given DPI. Drawn by the shared page
 * renderer, so it matches the editor (fonts, bubble shapes, art, cuts).
 */
export const exportLayoutToPNG = async (panels, layoutName = "layout", options = {}) => {
  const canvas = await renderPageToCanvas(panels, options);
  downloadDataUrl(canvas.toDataURL("image/png"), `${layoutName}.png`);
};
